{
  "version": 1,
  "asset_id": "a1f1148d-0018-4019-9b91-897cf0d85430",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/a1f1148d-0018-4019-9b91-897cf0d85430/clip-img_2109.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/a1f1148d-0018-4019-9b91-897cf0d85430/clip-img_2109.mp4",
  "original_filename": "clip-img_2109.mp4",
  "size": 367824,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:32:47Z"
}
